import type { CustomConfig } from './IUseAxios'
import { backendUrl } from '@nami/utils'

/**
 * Axios base configuration
 */
export const createAxiosConfig = (): CustomConfig => ({
    baseURL: backendUrl,
    withCredentials: true,
    noLoading: false,
    timeout: (import.meta as any).env.MODE === 'staging' ? 60000 : 30000,
})
